import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { CalendarService } from '../../services/calendar.service';
import { Event } from '../../models/calendar';
import {
  CalendarLoadAction,
  CalendarLoadSuccessAction,
  CalendarLoadErrorAction,
  CALENDAR_LOAD_REQUESTED
} from './actions';

@Injectable()
export class CalendarEffects {
  @Effect()
  public fetchCalendar$: Observable<
    CalendarLoadSuccessAction | CalendarLoadErrorAction
  > = this.actions.pipe(
    ofType(CALENDAR_LOAD_REQUESTED),
    mergeMap(
      (
        action: CalendarLoadAction
      ): Observable<CalendarLoadSuccessAction | CalendarLoadErrorAction> => {
        return this.calendarService.fetchData(action.payload).pipe(
          map((response: Event[]) => new CalendarLoadSuccessAction(response)),
          catchError((error: Error) =>
            of(new CalendarLoadErrorAction(error && error.message))
          )
        );
      }
    )
  );

  constructor(
    private actions: Actions,
    private calendarService: CalendarService
  ) {}
}
